<script>
import {
  mapActions,
  mapGetters
} from 'vuex'

export default {
  computed: {
    ...mapGetters([
      'components'
    ]),
    sorted_components() {
      return Object.keys(this.components).sort((a, b) => {
        const l1 = this.components[a].layout
        const l2 = this.components[b].layout
        return l1.y === l2.y ? l1.x - l2.x: l1.y - l2.y
      })
    }
  },
  data() {
    return {
      panels: []
    }
  },
  methods: {
    ...mapActions([
      'set_component_highlight'
    ]),
    highlight_comp(id, highlight) {
      this.set_component_highlight({id, highlight})
    }
  }
}
</script>

<template>
<div>
  <div class='component-list'>
    <v-expansion-panels v-model='panels' class='pa-0' flat focusable>
      <v-expansion-panel v-for='(id, i) in sorted_components' :key='i' class='item'>
        <v-expansion-panel-header
          @mouseenter='highlight_comp(id, true)'
          @mouseleave='highlight_comp(id, false)'>
          <div class='d-flex flex-column'>
            <div class='body-1 font-weight-bold'>{{components[id].title || 'No Title'}}</div>
            <div class='body-2'>{{id}}</div>
          </div>
        </v-expansion-panel-header>
        <v-expansion-panel-content class='pa-4'>
          <div v-if='ComponentSettingsDefaults[components[id].type] && components[id].settings'
            class='d-flex flex-wrap'>
            <candela-component-settings :component='components[id]'/>
          </div>
          <div v-else class='d-flex py-4 align-center justify-center flex-grow-1'>
            This component has no editable settings
          </div>
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>
  </div>
</div>
</template>

<style lang='sass' scoped>
.component-list
  max-height: 100%
  overflow: auto
  width: 100%

::v-deep .v-expansion-panel-header__icon
  i
    font-size: 1.0em

::v-deep .v-expansion-panel--active, .v-expansion-panel
  margin-bottom: 0 !important
  margin-top: 0 !important

.item
  transition: background-color 0.4s

.theme--dark
  .item
    border-bottom: 1px solid var(--v-grey-darken8)
    &:hover
      background-color: var(--v-grey-darken8)

.theme--light
  .item
    border-bottom: 1px solid var(--v-grey-lighten5)
    &:hover
      background-color: white
</style>
